module.exports = __webpack_public_path__ + "img/mycard.d01b0e86.png";